import { Component, OnInit, ChangeDetectionStrategy, Input, inject, DestroyRef } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { NavigationService } from '@nk/core/services/navigation.service';
import { NavigationItem } from '@nk/core/services/navigation.utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'nk-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MobileHeaderComponent implements OnInit {
  @Input() public backgroundColor = 'brand-color'; // primary, secondary, info, warning, danger, success
  public collapsedMainNav = true;
  public collapedUserNav = true;
  public navigationPaths$: Observable<NavigationItem[]>;
  private _destroy = inject(DestroyRef);

  constructor(
    private _navigationService: NavigationService,
    private _router: Router,
  ) {}

  public ngOnInit(): void {
    this.navigationPaths$ = this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(null),
      switchMap(() => this._navigationService.getNavigation()),
    );
    this._router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe(() => {
        this.collapsedMainNav = true;
        this.collapedUserNav = true;
      });
  }
}
